<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>
<div
    style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

    <div style="float: left;margin-top:5px; font-weight: normal!important;">

        <p-selectButton [options]="types" (onChange)='findAll()' [(ngModel)]="selectedType"></p-selectButton>

        Invitations Visa
    </div>
    <div style="float: right; cursor: pointer;">



        <button mat-icon-button (click)="sendVisa()" style="width: 150px;" label="Envoyer">
            <mat-icon>email</mat-icon>Envoyer
        </button>
        <button mat-icon-button (click)="printInvitation('pdf','i' )" style="width: 150px;" label="Exporter PDF"
            aria-label="Print douane">
            <mat-icon style="color: orange;">picture_as_pdf</mat-icon>Exporter PDF
        </button>




        <button mat-icon-button (click)="printInvitation('doc','i' )" style="width: 150px; " value="Exporter Word"
            aria-label="Print douane">
            <mat-icon> g_translate</mat-icon>Exporter Word
        </button>
        <mat-slide-toggle [(ngModel)]="isSigner" style="width: 150px;margin-right: 300px;">
            <span style="font-weight: normal;">Signature</span> </mat-slide-toggle>





    </div>

</div>


<mat-card-content style="height: 400px!important;">
    <div>


        <div style=" background: #F9F9F9;">

            <p-table [value]="invitations" #dt [(selection)]="selectedInvitation">
                <ng-template pTemplate="caption">
                    <div style="text-align: right">

                        <button
                            [cdkCopyToClipboard]="'http://ecatalog.napec-dz.com/exposant/VisaFormNAPEC2018.aspx?SALON=56&lg=en'">Copy
                            Guest link</button>

                        <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                        <input type="text" pInputText size="50" placeholder="Global Filter"
                            (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3em"></th>
                        <th>Entreprise</th>
                        <th>Nom</th>
                        <th>Nationalite</th>
                        <th>Email</th>
                        <th>Pays</th>
                        <th>Type Client</th>
                        <th>Date impression</th>
                    </tr>

                </ng-template>
                <ng-template pTemplate="body" let-car>
                    <tr [pSelectableRow]="car">
                        <td>
                            <p-tableRadioButton [value]="car"></p-tableRadioButton>
                        </td>
                        <td>{{car.participant}}</td>
                        <td>{{car.nom}} {{car.prenom}}</td>


                        <td pEditableColumn>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" (change)='updateInviation(car)'
                                        [(ngModel)]="car.nationalite" required>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{car.nationalite}}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td>{{car.email}}</td>

                        <td>{{car.paysString}}</td>
                        <td>{{car.typeClient}}</td>


                        <td>{{car.date_impression | date : 'dd/MM/yyyy'}}</td>
                    </tr>
                </ng-template>
            </p-table>

        </div>
    </div>

</mat-card-content>